module.exports = __webpack_public_path__ + "bundle.0.e5c013a870f2189fb8f3.worker.js"